import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "as-league_title" }
const _hoisted_2 = { class: "as-match_competition" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "as-match__corner as-d-none as-d-lg-flex" }
const _hoisted_5 = { class: "as-match__yellow-goal as-d-none as-d-lg-flex" }
const _hoisted_6 = ["data-id"]
const _hoisted_7 = { class: "as-match__item--wrap" }
const _hoisted_8 = { class: "as-match__sm" }
const _hoisted_9 = { class: "as-match__label" }
const _hoisted_10 = { class: "as-match__label-item" }
const _hoisted_11 = {
  key: 0,
  class: "as-match__label-item"
}
const _hoisted_12 = { class: "as-match__video-highlight as-d-flex as-d-lg-none" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "as-match__label as-d-flex as-d-lg-none" }
const _hoisted_15 = { class: "as-match__label-item" }
const _hoisted_16 = { class: "as-match__label-item" }
const _hoisted_17 = { class: "as-match__scores as-match__teams" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "as-match__team--name as-match__team-home-name" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "as-match__team--name as-match__team-away-name" }
const _hoisted_25 = { class: "as-match__video-highlight as-d-none as-d-lg-flex" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "as-match__ht as-d-none as-d-lg-flex" }
const _hoisted_28 = { class: "as-ht-btn" }
const _hoisted_29 = { class: "as-match__corner as-d-none as-d-lg-flex" }
const _hoisted_30 = { class: "as-match__label-item" }
const _hoisted_31 = { class: "as-match__yellow-goal as-d-none as-d-lg-flex" }
const _hoisted_32 = { class: "as-match__label-item" }
const _hoisted_33 = {
  key: 0,
  class: "as-match__item--wrap as-p-0"
}
const _hoisted_34 = { class: "as-score-detail" }

import { onMounted, onUnmounted, ref, reactive, computed } from "vue";
import SvgSprite from "~src/components/matches/SvgSprite.vue";
import MatchEnum from "~src/enums/MatchEnum";
import PopupComponent from "~src/modules/result/components/PopupComponent.vue";
import Loading from "~src/components/Loading.vue";
import IconPlay from "~src/components/icons/IconPlay.vue";
import type { ICompetitions, IMatch, IFilterResult } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  getRoundName,
  getTeamNameShow,
  getCompetitionNameShow,
} from "~src/helpers";
import IconCornerNew from "~src/components/icons/IconCornerNew.vue";
import IconYellowCard from "~src/components/icons/IconYellowCard.vue";
import ScoreVs from "~src/components/matches/ScoreVs.vue";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  competitions?: Array<ICompetitions>;
  filter: IFilterResult;
  competitionType: number;
  isLoadMoreInverse: boolean;
  isLoadInverse: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Matches',
  props: {
    competitions: { default: () => [] },
    filter: {},
    competitionType: { default: 0 },
    isLoadMoreInverse: { type: Boolean },
    isLoadInverse: { type: Boolean }
  },
  emits: ["loadInverse"],
  setup(__props: any, { emit: __emit }) {

const commonStore = usecommonStore();
const emits = __emit;

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const page = ref(1);
const isLoadMore = ref(false);
const competitionEnd = ref(0);
const scrollComponent = ref<HTMLElement | null>(null);
const leagues = ref<Array<ICompetitions>>([]);
const isShowPopup = ref(false);
const competitionPopup = ref<ICompetitions | null>(null);
const matchPopup = ref<IMatch | null>(null);

const openPopup = (match: IMatch, competition: ICompetitions) => {
  if (
    [...MatchEnum.LIST_STATUS_PLAYING, MatchEnum.STATUS_END].includes(
      match.status_id
    )
  ) {
    competitionPopup.value = competition;
    matchPopup.value = match;
    isShowPopup.value = true;

    // const body = document.body;
    // body.style.overflow = "hidden";
  }
};

const closePopup = () => {
  isShowPopup.value = false;
  // const body = document.body;
  // body.style.overflow = "auto";
};

onMounted(() => {
  loadMoreLeagues();
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const getLeagues = () => {
  const limit = 50;
  const offset = page.value * limit;

  let count = 0;
  let datas: Array<ICompetitions> = [];
  props.competitions.forEach((competition: ICompetitions, index: any) => {
    if (
      (competitionEnd.value === 0 || competitionEnd.value < index) &&
      count < offset
    ) {
      datas.push(competition);
      if (competitionEnd.value < index) {
        competitionEnd.value = index;
      }
      count += competition.matchs.length;
    }
  });

  return datas;
};

const loadMoreLeagues = () => {
  if (
    isLoadMore.value &&
    props.competitions.length - 1 === competitionEnd.value
  ) {
    return;
  }
  isLoadMore.value = true;
  page.value = page.value + 1;
  let newleagues = getLeagues();
  leagues.value.push(...newleagues);
};

const handleScroll = (e: any) => {
  let element = scrollComponent.value;
  if (
    element &&
    element.getBoundingClientRect().bottom < window.window.innerHeight + 300
  ) {
    loadMoreLeagues();
  }
};

const getScoreDetail = (match: IMatch): string => {
  if (match.status_id !== MatchEnum.STATUS_END) {
    return "";
  }

  const homeTeamName = getTeamNameShow(match.home_team);
  const awayTeamName = getTeamNameShow(match.away_team);

  let scoreDetails = [];
  let advancingTeam: string | undefined = "";
  let winner = "";

  // Calculate match scores details
  const hasExtraTime = match.home_scores[5] > 0 || match.away_scores[5] > 0;
  const hasPenalties = match.home_scores[6] > 0 || match.away_scores[6] > 0;

  if (hasExtraTime || hasPenalties) {
    scoreDetails.push(
      `90 Phút [${match.home_scores[0]}-${match.away_scores[0]}]`
    );
  }
  if (hasExtraTime) {
    scoreDetails.push(
      `120 Phút [${match.home_scores[5]}-${match.away_scores[5]}]`
    );
  }
  if (hasPenalties) {
    scoreDetails.push(`Pen [${match.home_scores[6]}-${match.away_scores[6]}]`);
  }

  let aggregateHome: number = 0;
  let aggregateAway: number = 0;

  // Determine the winner
  if (match.leg && match.leg == "Second Leg") {
    if (match.agg_score && match.agg_score.length) {
      // check trường hợp trận chưa kết thúc lượt đi chưa cộng vs lượt về
      const isAggScoreTotal = parseInt(match.agg_score[0]) - match.home_scores[0] >= 0 && parseInt(match.agg_score[1]) - match.away_scores[0] >= 0;

      aggregateHome = isAggScoreTotal ? match.agg_score[0] : parseInt(match.agg_score[0]) + match.home_scores[0];
      aggregateAway = isAggScoreTotal ? match.agg_score[1] : parseInt(match.agg_score[0]) + match.away_scores[0];

      if (aggregateHome === aggregateAway) {
        winner = match.home_scores[6] > match.away_scores[6] ? homeTeamName : awayTeamName;
      } else {
        winner = aggregateHome > aggregateAway ? homeTeamName : awayTeamName;
      }
    } else if (
      match.home_scores[5] !== 0 ||
      match.away_scores[5] !== 0 ||
      match.home_scores[6] !== 0 ||
      match.away_scores[6] !== 0
    ) {
      if (
        match.home_scores[0] > match.away_scores[0] ||
        match.home_scores[5] > match.away_scores[5] ||
        match.home_scores[6] > match.away_scores[6]
      ) {
        winner = homeTeamName;
      } else if (
        match.home_scores[0] < match.away_scores[0] ||
        match.away_scores[5] > match.home_scores[5] ||
        match.away_scores[6] > match.home_scores[6]
      ) {
        winner = awayTeamName;
      }
    }
  } else if (
    match.home_scores[5] !== 0 ||
    match.away_scores[5] !== 0 ||
    match.home_scores[6] !== 0 ||
    match.away_scores[6] !== 0
  ) {
    if (
      match.home_scores[0] > match.away_scores[0] ||
      match.home_scores[5] > match.away_scores[5] ||
      match.home_scores[6] > match.away_scores[6]
    ) {
      winner = homeTeamName;
    } else if (
      match.home_scores[0] < match.away_scores[0] ||
      match.away_scores[5] > match.home_scores[5] ||
      match.away_scores[6] > match.home_scores[6]
    ) {
      winner = awayTeamName;
    }
  }

  // Handle leg information
  if (match.agg_score && match.leg && match.leg == "Second Leg") {
    if (match.agg_score.length) {
      const isOvertimeScore = match.home_scores[5] > 0 || match.away_scores[5] > 0;

      const legHomeScore = isOvertimeScore ? aggregateHome - match.home_scores[5] : aggregateHome - match.home_scores[0];
      const legAwayScore = isOvertimeScore ? aggregateAway - match.away_scores[5] : aggregateAway - match.away_scores[0];
      scoreDetails.push(
        `Lượt đi ${awayTeamName} ${legAwayScore}:${legHomeScore} ${homeTeamName}`
      );
    }

    advancingTeam = "";
    if (aggregateHome > aggregateAway) {
      advancingTeam = homeTeamName;
    } else if (aggregateHome < aggregateAway) {
      advancingTeam = awayTeamName;
    } else if (winner.length > 0) {
      advancingTeam = winner;
    }

    if (advancingTeam) {
      scoreDetails.push(`${advancingTeam} Tiến vào vòng trong`);
    } else if (winner) {
      scoreDetails.push(`${winner} thắng`);
    }
  } else if (winner) {
    scoreDetails.push(`${winner} thắng`);
  }

  return scoreDetails.join(", ");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SvgSprite),
    _createElementVNode("div", {
      class: "as-matches",
      ref_key: "scrollComponent",
      ref: scrollComponent
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leagues.value, (competition) => {
        return (_openBlock(), _createElementBlock("div", {
          key: competition.id,
          class: _normalizeClass(`as-competition-wrapper as-competition-wrapper-${siteName.value}`)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "as-lazyload",
                src: _ctx.getImgUrlBySport('competition', competition.id),
                alt: _unref(getCompetitionNameShow)(competition)
              }, null, 8, _hoisted_3),
              _createTextVNode(_toDisplayString(competition?.short_name || competition?.name), 1)
            ]),
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"as-match__teams as-d-none as-d-lg-flex\"><div class=\"as-match__team as-match__team--home\">Chủ nhà</div><div class=\"as-scoreboard\">Tỷ số</div><div class=\"as-match__team as-match__team--away\">Khách</div></div><div class=\"as-match__video-highlight as-d-none as-d-lg-flex\"></div><div class=\"as-match__ht as-d-none as-d-lg-flex\">HT</div>", 3)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(IconCornerNew, { width: 12 }),
              _cache[1] || (_cache[1] = _createTextVNode(" HT | FT "))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(IconYellowCard, {
                width: 12,
                height: 16
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" HT | FT "))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competition.matchs, (match) => {
            return (_openBlock(), _createElementBlock("div", {
              key: match.id,
              "data-id": match.id,
              class: "as-match__item"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatLocalTime)(match.match_time, "h:mm DD/MM")), 1),
                    (match.round?.round_num && match.round?.round_num != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(`Vòng ${match.round?.round_num}`), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (match.highlight)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: match.highlight?.url,
                          rel: "nofollow",
                          title: "Xem video highlight"
                        }, [
                          _createVNode(IconPlay, { fill: "#c72a1d" })
                        ], 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "as-active" }, "HT", -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass({
                      'as-label-item-win':
                        match.home_scores[1] > match.away_scores[1],
                    })
                        }, _toDisplayString(match.home_scores[1]), 3),
                        _cache[4] || (_cache[4] = _createElementVNode("span", null, " - ", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass({
                      'as-label-item-win':
                        match.home_scores[1] < match.away_scores[1],
                    })
                        }, _toDisplayString(match.away_scores[1]), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(IconCornerNew),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass({
                      'as-label-item-win':
                        match.home_scores[4] > match.away_scores[4],
                    })
                        }, _toDisplayString(match.home_scores[4]), 3),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, " - ", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass({
                      'as-label-item-win':
                        match.home_scores[4] < match.away_scores[4],
                    })
                        }, _toDisplayString(match.away_scores[4]), 3)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", {
                    href: _ctx.getLinkTeamDetail(match.home_team?.id, _unref(getTeamNameShow)(match.home_team)),
                    class: "as-match__team as-match__team--home"
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrlBySport('team', match.home_team?.id),
                      alt: _unref(getTeamNameShow)(match.home_team),
                      class: "as-match__team--logo"
                    }, null, 8, _hoisted_19),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(getTeamNameShow)(match.home_team)), 1)
                  ], 8, _hoisted_18),
                  _createElementVNode("div", {
                    class: "as-scoreboard",
                    onClick: ($event: any) => (openPopup(match, competition))
                  }, [
                    _createVNode(ScoreVs, {
                      match: match,
                      size: 28
                    }, null, 8, ["match"])
                  ], 8, _hoisted_21),
                  _createElementVNode("a", {
                    href: _ctx.getLinkTeamDetail(match.away_team?.id, _unref(getTeamNameShow)(match.away_team)),
                    class: "as-match__team as-match__team--away"
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrlBySport('team', match.away_team?.id),
                      alt: _unref(getTeamNameShow)(match.away_team),
                      class: "as-match__team--logo"
                    }, null, 8, _hoisted_23),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(getTeamNameShow)(match.away_team)), 1)
                  ], 8, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (match.highlight)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: match.highlight?.url,
                        rel: "nofollow",
                        title: "Xem video highlight",
                        class: "as-match__play-highlight"
                      }, " Xem Highlight ", 8, _hoisted_26))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  'as-label-item-win':
                    match.home_scores[1] > match.away_scores[1],
                })
                    }, _toDisplayString(match.home_scores[1]), 3),
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, ":", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  'as-label-item-win':
                    match.home_scores[1] < match.away_scores[1],
                })
                    }, _toDisplayString(match.away_scores[1]), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[2]?.[0] || 0) > (match.half_time_statistics?.p1?.[2]?.[1] || 0),
                })
                    }, _toDisplayString(match.half_time_statistics?.p1?.[2]?.[0] || 0), 3),
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "-", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[2]?.[0] || 0) < (match.half_time_statistics?.p1?.[2]?.[1] || 0),
                })
                    }, _toDisplayString(match.half_time_statistics?.p1?.[2]?.[1] || 0), 3),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "as-separator" }, "|", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  'as-label-item-win':
                    match.home_scores[4] > match.away_scores[4],
                })
                    }, _toDisplayString(match.home_scores[4]), 3),
                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "-", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  'as-label-item-win':
                    match.home_scores[4] < match.away_scores[4],
                })
                    }, _toDisplayString(match.away_scores[4]), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[3]?.[0] || 0) > (match.half_time_statistics?.p1?.[3]?.[1] || 0),
                })
                    }, _toDisplayString(match.half_time_statistics?.p1?.[3]?.[0] || 0), 3),
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "-", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[3]?.[0] || 0) < (match.half_time_statistics?.p1?.[3]?.[1] || 0),
                })
                    }, _toDisplayString(match.half_time_statistics?.p1?.[3]?.[1] || 0), 3),
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "as-separator" }, "|", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  'as-label-item-win':
                    match.home_scores[3] > match.away_scores[3],
                })
                    }, _toDisplayString(match.home_scores[3]), 3),
                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "-", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  'as-label-item-win':
                    match.home_scores[3] < match.away_scores[3],
                })
                    }, _toDisplayString(match.away_scores[3]), 3)
                  ])
                ])
              ]),
              (
          match.home_scores[6] ||
            (match.agg_score && match.agg_score.length > 0)
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "as-d-flex as-w-100 as-justify-content-between" }, null, -1)),
                    _createElementVNode("div", _hoisted_34, _toDisplayString(getScoreDetail(match)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6))
          }), 128))
        ], 2))
      }), 128)),
      (_ctx.isLoadMoreInverse)
        ? (_openBlock(), _createBlock(Loading, {
            key: 0,
            class: "as-mt-24"
          }))
        : _createCommentVNode("", true),
      (isShowPopup.value)
        ? (_openBlock(), _createBlock(PopupComponent, {
            key: 1,
            isShowPopup: isShowPopup.value,
            match: matchPopup.value,
            competition: competitionPopup.value,
            onToggle: _cache[0] || (_cache[0] = ($event: any) => (closePopup()))
          }, null, 8, ["isShowPopup", "match", "competition"]))
        : _createCommentVNode("", true)
    ], 512)
  ], 64))
}
}

})